export default __webpack_public_path__ + "static/media/not_found.b1ffdf88.png";